module.exports = __webpack_public_path__ + "c043c235ed3e6c764e8c0d4b6c00f96d.fbx";